import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { AssignmentCustomerResponse, AssignmentPspResponse } from '../../../../api';
import { BaseAvatarSize } from '../../../shared/components/avatar/base-avatar.component';
import { BaseDateService } from '../../../shared/services/base-date.service';
import { BaseDeregisterFormInterface } from '../../_interfaces/base-deregister-candidate-modal.interface';
import { BaseFormatDatePipe } from '../../../shared/pipes/base-format-date.pipe';
import { toNgbDateStruct } from '../../../shared/constants/base-datepicker.const';

type AssignmentResponse = AssignmentCustomerResponse | AssignmentPspResponse;

@Component({
  selector: 'base-deregister-candidate-modal',
  templateUrl: './base-deregister-candidate-modal.component.html',
})
export class BaseDeregisterCandidateModalComponent implements OnChanges, OnInit {
  @Input() form: FormGroup<BaseDeregisterFormInterface>;
  @Input() assignment: AssignmentResponse | undefined;
  @Input() isFormSubmitted = false;
  avatarSize = BaseAvatarSize;
  minDate: { year: number; month: number; day: number };
  maxDate: { year: number; month: number; day: number };
  isFirstDatesEqual: boolean;
  newPeriodMessage: string;

  constructor(private datePipe: BaseFormatDatePipe) {}

  ngOnInit() {
    this.handleCancellationPeriodDate();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.assignment && changes?.assignment?.currentValue) {
      const min = BaseDateService.toDate(this.assignment.startDate);
      const max = BaseDateService.toDate(this.assignment.endDate);
      // Deregistration can only be backdated to the 1st day of the previous month, so when the
      // assignment starts earlier than that floor we clamp the min date up to it.
      this.minDate = BaseDateService.getLaterNgbDateStruct(
        toNgbDateStruct(min),
        BaseDateService.getFirstDayOfPreviousMonth()
      );
      this.maxDate = toNgbDateStruct(max);
    }
  }

  hasCustomerProfilePersonalId(assignment: AssignmentResponse | undefined): assignment is AssignmentCustomerResponse {
    return (
      !!assignment &&
      'profile' in assignment &&
      typeof (assignment as AssignmentCustomerResponse).profile?.customerProfilePersonalId === 'string'
    );
  }

  private handleCancellationPeriodDate(): void {
    this.form.controls['cancelationDate'].valueChanges.subscribe((date) => {
      if (!this.assignment) {
        return;
      }

      this.isFirstDatesEqual = BaseDateService.isEqual(new Date(this.assignment.startDate), new Date(date));
      const currentDate = new Date(date);
      const endDate = currentDate.setDate(currentDate.getDate() - 1);
      this.newPeriodMessage = `${this.datePipe.transform(
        new Date(this.assignment.startDate)
      )} - ${this.datePipe.transform(new Date(endDate))}`;
    });
  }
}
